import actions from "./actions";

const {
    FETCH_PREDICTED_GRADES,
    FETCH_PREDICTED_GRADES_REPORT,
    FETCH_SINGLE_STUDENT_PREDICTED_GRADE_TRANSCRIPT,
    FETCH_PREDICTED_GRADES_RESET,
} = actions;

const initState = {
    predictedGrades: [],
    predictedGradesReport: [],
    singleStudentTranscript: null,
};

const PredictedGradeReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_PREDICTED_GRADES:
            return {
                ...state,
                predictedGrades: data,
            };
        case FETCH_PREDICTED_GRADES_REPORT:
            return {
                ...state,
                predictedGradesReport: data,
            };
        case FETCH_SINGLE_STUDENT_PREDICTED_GRADE_TRANSCRIPT:
            return {
                ...state,
                singleStudentTranscript: data,
            };
        case FETCH_PREDICTED_GRADES_RESET:
            return {
                ...state,
                predictedGrades: initState.predictedGrades,
                predictedGradesReport: initState.predictedGradesReport,
                singleStudentTranscript: initState.singleStudentTranscript,
            };
        default:
            return state;
    }
};

export default PredictedGradeReducer;